import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { error } from 'console';
import { FirestoreService } from 'src/app/data/services/firestore.service';

@Component({
  selector: 'app-cedula-modal',
  templateUrl: './cedula-modal.component.html',
  styleUrls: ['./cedula-modal.component.scss'],
})
export class CedulaModalComponent implements OnInit {

  @Input() userData: any; // Recibe los datos
  cedula: number;
  cargando: boolean = false

  constructor(private modalCtrl: ModalController,
              private fireStoreService: FirestoreService,
               public alertController: AlertController,
  ) { }

  ngOnInit() {
  
  }

  salir(){
  }
  
  validaCampo(){
    if(!this.cedula){
      this.alertaLlenarCampos()
    }else{
      this.cargando = true
      this.actualizarDatos()
    }
  }

  async alertaLlenarCampos() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Campos vacios',
      message: 'Recuerda llenar el campo cedula',
      buttons: [
        {
          text: 'Ok',
          cssClass: 'validador-perfiles'
        },
      ],
      backdropDismiss: false
    });
    await alert.present();
  }

  actualizarDatos(){
    this.fireStoreService.actualizarDatoCedula('users', this.userData.uid, { cedula: this.cedula })
    .then(() => {
      this.cargando= false
      this.modalCtrl.dismiss()
    })
    .catch(error => {
      this.cargando= false
      
      console.log(error.message)
    })
  }

  

}
